import { MessagingTopology, OutputTargetNode } from '@internal/open-catalog';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { MessagingExchangeIcon } from '../../../../../../components/icons';
import { BindingsPanel } from './panel.bindings';
import { SelectedPanel } from './panel.selected';
import { MessagingNodeData } from '../flow';

export function OutputTargetToolbar(props: {
  data: MessagingNodeData,
  topology: MessagingTopology,
  onTopologyChange: (newNodeName?: string) => void
}) {

  const { data, topology, onTopologyChange } = props;
  const { spec } = data;

  const [expanded, setExpanded] = useState<string>('bindings');
  const [target, setTarget] = useState<OutputTargetNode>();

  const handleAccordionStateChange = (panel: any) => (_event: ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const onBindingsChange = (): void => {
    onTopologyChange();
  }

  useEffect(() => {
    setTarget(spec as OutputTargetNode);
  }, [spec, setTarget])

  return (<>
    <SelectedPanel data={data} icon={<MessagingExchangeIcon />} />
    {target && topology.output && (
      <BindingsPanel data={data} expanded={expanded} onAccordionStateChange={handleAccordionStateChange}
        source={topology.output} destination={target} onBindingsChange={onBindingsChange}
      />
    )}
  </>);
}
